(function () {
	'use strict';

	const modules = [];

	angular.module('DcExpositionModule', modules);
})();
